module.exports = __webpack_public_path__ + "static/img/db-life-smart-phone-sales-thumb.821a51e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/db-life-smart-phone-sales-thumb.jpg
// module id = cx05
// module chunks = 0